@property --cartesian-data-len {
  syntax: '<integer>';
  inherits: false;
  initial-value: 0;
}
@property --cartesian-bar-slot {
  syntax: '<length>';
  inherits: false;
  initial-value: 28px;
}
@property --cartesian-axis-chrome {
  syntax: '<length>';
  inherits: false;
  initial-value: 80px;
}
@property --cartesian-min-tile-height {
  syntax: '<length>';
  inherits: false;
  initial-value: 300px;
}
@property --cartesian-max-tile-height {
  syntax: '<length>';
  inherits: false;
  initial-value: 500px;
}
@property --cartesian-aspect-ratio {
  syntax: '<number>';
  inherits: false;
  initial-value: 2.5;
}

.cartesian-chart {
  display: grid;
  place-self: center;
  width: 100%;
  /* max-width: calc(4 * var(--cartesian-max-tile-height)); */
  max-width: calc(100cqw - 2 * 18px - 2 * var(--mantine-spacing-sm));
  min-height: var(--cartesian-min-tile-height);
  max-height: var(--cartesian-max-tile-height);
  aspect-ratio: var(--cartesian-aspect-ratio);
  padding: var(--mantine-spacing-sm);

  > * {
    width: 100%;
    height: 100%;
  }

  &[data-orientation='horizontal'] {
    max-width: none;
    min-height: 0;
    max-height: 80dvh;
    aspect-ratio: auto;
    overflow-y: auto;

    > * {
      height: max(
        var(--cartesian-min-tile-height),
        calc(var(--cartesian-data-len) * var(--cartesian-bar-slot) + var(--cartesian-axis-chrome))
      );
    }
  }

  :fullscreen & {
    place-self: stretch;
    max-width: none;
    max-height: none;
    aspect-ratio: auto;
    margin: 0;
    overflow: visible;

    > * {
      block-size: 100%;
      height: auto;
    }
  }
}

.chart {
  margin: auto;
}

/* Adaptive layout: when the enclosing `TileFrame` shrinks, dial down
   axis chrome so the plot area stays legible at small tile widths.
   Drives via the `tile` container that `TileFrame` defines — not via
   media queries — so this composes correctly with whatever grid-span
   the dashboard chooses. */
/* @container tile (inline-size < 480px) { */
/*   .cartesian-chart { */
/*     margin: var(--mantine-spacing-2xs); */
/*     :global(.recharts-cartesian-axis-tick-value), */
/*     :global(.recharts-legend-item-text) { */
/*       font-size: var(--mantine-font-size-xs); */
/*     } */
/*     :global(.recharts-label) { */
/*       display: none; */
/*     } */
/*   } */
/* } */

.tooltip {
  :global {
    display: flex;
    flex-flow: column nowrap;
    gap: var(--mantine-spacing-xs);
    padding: var(--mantine-spacing-xs);
    font-size: var(--mantine-font-size-sm);
    white-space: nowrap;
    /* biome-ignore lint/complexity/noImportantStyles: overrides recharts' inline tooltip element style */
    background-color: alpha(var(--mantine-color-dark-8), 0.7) !important;
    /* biome-ignore lint/complexity/noImportantStyles: overrides recharts' inline tooltip element style */
    border: 1px solid var(--mantine-color-dark-4) !important;
    border-radius: var(--mantine-radius-sm);
    box-shadow: var(--mantine-shadow-sm), var(--mantine-shadow-lg);
    backdrop-filter: blur(var(--mantine-radius-md));
    .recharts-tooltip-label {
      font-size: var(--mantine-font-size-lg);
      font-weight: 600;
    }
    .recharts-tooltip-item-list {
      display: grid;
      grid-template-columns: repeat(3, auto);
      gap: var(--mantine-spacing-xs);
      align-items: baseline;
    }
    .recharts-tooltip-item {
      /* biome-ignore lint/complexity/noImportantStyles: overrides recharts' inline tooltip-item display style */
      display: contents !important;
      padding: 0;
    }
    .recharts-tooltip-item-name {
      &::before {
        display: inline-block;
        width: 0.5rem;
        height: 0.5rem;
        margin-inline-end: var(--mantine-spacing-xs);
        vertical-align: center;
        content: '';
        background: currentColor;
      }
    }
    .recharts-tooltip-item-separator {
      display: none;
    }
    .recharts-tooltip-item-value {
      font-weight: 600;
      color: var(--mantine-color-dark-0);
    }
    .recharts-tooltip-item-unit {
      font-size: var(--mantine-font-size-xs);
      color: var(--mantine-color-dark-0);
    }
  }
}
